export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) { return }
  const nuxtApp = useNuxtApp()
  nuxtApp.$gtmReset()
  if (from.name && to.name && from.name === to.name) {
    to.meta = from.meta
  }
})
